<template>
  <OverlayLoader class="h-full" :loading="fetching" loader-size="100">
    <BioSitePage @exit="close" />
  </OverlayLoader>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BioSitePage from "~/components/pages/bio-site/BioSitePage";
import { useBioSiteStore } from "~/components/pages/bio-site/BioSitePage/store";
import { BioSite } from "~/models/dobby/BioSite";

export default defineComponent({
  components: { BioSitePage },
  setup() {
    definePageMeta({
      layout: "canvas",
    });

    const store = useBioSiteStore();
    const route = useRoute();
    const router = useRouter();
    const { fetching } = storeToRefs(store);
    const handle = computed(() => String(route.params.handle));

    store.setHandle(handle.value);

    const getBioSite = async () => {
      fetching.value = true;

      const site = await BioSite.selectAll().findUnique({
        handle: handle.value,
      });

      fetching.value = false;

      if (!site) {
        // context.root.$nuxt.error({ statusCode: 404 })
        throw new Error("404");
      }

      store.load(site!.getTransfer());

      fetching.value = false;
    };

    const close = () => {
      if (history.length) {
        router.back();
      } else {
        router.push({ name: "bio-sites" });
      }
    };

    onMounted(getBioSite);

    return {
      fetching,
      close,
    };
  },
});
</script>
